<!--  -->
<template>
  <login v-if="$store.state.pageState=='login'" />
  <home v-if="$store.state.pageState=='home'" />
  <selectClubs v-if="$store.state.pageState=='home'" />
  <medicalRecord v-if="$store.state.pageState=='medicalRecord'" />
  <div class="loading" :class="$store.state.loading ? 'showLoading' : 'hideLoading'"></div>
</template>

<script>
import home from "./views/home/home.vue";
import login from "./views/login/login.vue";
import medicalRecord from './views/medicalRecord/medicalRecord.vue';
import selectClubs from '/src/components/selector/selectClub.vue';
export default {
  components: {
    home,
    login,
    selectClubs,
    medicalRecord
  },
  data() {
    return {
    };
  },
  methods: {
    init() {
      // 根据 URL 判断是否是病历查看页面
      if (window.location.hash.includes("#/medicalRecord")) {
        this.$store.commit("setPageState", "medicalRecord");
        return;
      }
      // 有 token 则自动恢复登录状态，否则由路由守卫处理跳转到登录页
      const token = localStorage.getItem('token');
      if (token) {
        this.$store.commit("getUserInfo", { type: "auto" });
      } else {
        this.$store.commit("setPageState", "login");
      }
    },
  },
  mounted() {
    this.init()
  },
};
</script>

<style scoped>
</style>
<!--  -->